import Button from 'react-bootstrap/Button';

export default function CustomButton({ text, path, onClick, type = "button", size = "md", buttonType = 1, require = false}) {
    
    const baseStyles = "py-2 rounded-3 border-0 text-white";
  
    const padding = {
        md: "px-4",
        lg: "px-5"
    }

    return (
      <Button className={`js-sm-center ${require ? '' : 'd-none'} d-md-block ${padding[size]} ${baseStyles} button-primary`} onClick={()=>onClick(path)} type={type}>
        {text}
      </Button>
    );
  }
  